<form>
  <ng-container *transloco="let t; read: 'ime.common.units'">
    <mes-api-response-summary class="d-none" [response]="response"></mes-api-response-summary>
    <div class="form-group row">
      <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="code" name="code" [(ngModel)]="unit.Code">
      </div>
    </div>
    <div class="form-group row">
      <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="unit.Name">
      </div>
    </div>
    <div class="form-group row">
      <label for="PhysicalDimension" class="col-sm-4 col-form-label">{{t('Physical Dimension')}}</label>
      <div class="col-sm-8">
        <mes-web-classificator-value-select name="PhysicalDimension" id="PhysicalDimension" [items$]="classificatorValueService.physicalDimensions$" [entityId]="unit.PhysicalDimensionClv" (entityIdChange)="unit.PhysicalDimensionClv = $event"></mes-web-classificator-value-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="RoundingFactor" class="col-sm-4 col-form-label">{{t('Rounding Factor')}}</label>
      <div class="col-sm-8">
        <input type="number" class="form-control" id="RoundingFactor" name="RoundingFactor" [(ngModel)]="unit.RoundingFactor">
        <small id="RoundingFactorHelp" class="form-text text-muted" *ngIf="unit.RoundingFactor">Example value: {{getPow(unit.RoundingFactor)}}</small>
      </div>
    </div>
    <div class="form-group row">
      <label for="Comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="Comment" id="Comment" [(ngModel)]="unit.Comment"></textarea>
      </div>
    </div>
  </ng-container>
</form>

